import React, { useContext } from 'react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { UserTutorialCards, UserTutorialCardSp } from './UserTutorialCards';
import { UserTutorialCompletionContext } from '../../../contexts/userTutorialCompletion';

export const UserTutorialHeader = () => {
  const nonSp = GlobalStatesV3.viewport.isNonSp;
  const { resource } = useContext(UserTutorialCompletionContext);

  const showTutorials = () => {
    return resource.showUserTutorials();
  };

  return <div>{showTutorials() && <div>{nonSp ? <UserTutorialCards /> : <UserTutorialCardSp />}</div>}</div>;
};
